import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DxDataGridComponent } from "devextreme-angular";
import { Configuration } from "../../core/configuration/configuration";
import { SessionHelper } from "../../core/helper/sessionHelper";
import { A3LCompany } from "../../core/models/a3LCompany.model";
import { BolsaVacaciones } from "../../core/models/bolsaVacaciones.model";
import { DatosCalculoBolsaVacaciones } from "../../core/models/datosCalculo.model";
import { PeriodosBolsaVacacionesModel } from "../../core/models/periodosBolsaVacaciones.model";
import { Vacaciones } from "../../core/models/vacaciones.model";
import { DatoCalculoService } from "../../core/services/datosCalculo.service";
import { VacacionesService } from "../../core/services/vacaciones.service";


@Component({
  selector: 'app-dias-solicitados-vs-reales',
  templateUrl: './dias-solicitados-vs-reales.component.html',
  styleUrls: ['./dias-solicitados-vs-reales.component.scss'],
  providers: [VacacionesService, DatoCalculoService]
})
export class DiasSolicitadosVsRealesComponent implements OnInit {


  @ViewChild('gridPeriodos', { static: false }) dataGrid: DxDataGridComponent;

  panelIcon = 'scroll'; // material icon
  panelTitle = 'Días de vacaciones solicitado contra días que le corresponde';
  panelDescription = '';

  holidays: Vacaciones[] = new Array<Vacaciones>();

  periodos: PeriodosBolsaVacacionesModel[] = new Array<PeriodosBolsaVacacionesModel>();

  companies: A3LCompany[] = new Array<A3LCompany>();
  calculos: DatosCalculoBolsaVacaciones [] = new Array<DatosCalculoBolsaVacaciones>();
  calculosSeleccionados: DatosCalculoBolsaVacaciones[] = new Array<DatosCalculoBolsaVacaciones>();
  selectedCompany: number;
  selectedYear: number;

  constructor(
    private _vacacionesService: VacacionesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sessionHelper: SessionHelper) {
      this.selectedCompany = this._sessionHelper.LastCompanySelectedBolsaVacaciones;
    }

  ngOnInit() {
    setTimeout(() => {
      if(this.selectedCompany){
        this.onSearch();
      }
    }, 60);
  }

  getHolidays(){
    this._vacacionesService.getAllByCompanyAndYear(this.selectedCompany, this.selectedYear).subscribe((response: Vacaciones[]) => {
      if (response){
        this.holidays = response;
      }
    });
  }

  getRiesgo(rowData): number {
    const riesgo = rowData.DiasReales - rowData.Realizados;

    if(riesgo > 0)
      return 0;
    else
      return riesgo;
  }


  onSearch() {
    this._sessionHelper.LastCompanySelectedBolsaVacaciones = this.selectedCompany;
    this.getHolidays();

  }

  onClickEdit(row: BolsaVacaciones) {
      this._router.navigate([Configuration.editPath, row.Id], {
         relativeTo: this._activatedRoute,
         state: row
      });
  }

  onSelectedTabChange() {
    // console.log(this.dataGrid.dataSource);
    this.dataGrid.instance.repaint();
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
        e.editorOptions.stylingMode = 'underlined';
    }
  }

}

